
import Vue from 'vue';
import EuButton from '../Button/Button.vue';
import EuCard from '../Card/Card.vue';
/**
 - The header section is default slot, you can make it text & background only, or image only with props <b>image</b>
 - Header section can be modified thru class <b>.eu-generalinfographic-header</b>
 - Body and Footer is customizable thru slots <b> v-slot:body | v-slot:footer </b>
 */
export default Vue.extend<any, any, any, any>({
  name: 'GeneralInfographicCard',
  components: {
    EuButton,
    EuCard
  },
  props: {
    /**
     * Set id
     */
    id: {
      type: [Number, String],
      default: ''
    },
    /**
     * Set card elevation type (sort by thickness: thin, interactive, float, thicker)
     */
    elevation: {
      type: String,
      default: ''
    },
    /**
     * Set title
     */
    title: {
      type: String,
      default: ''
    },
    /**
     * Set content text
     */
    content: {
      type: String,
      default: ''
    },
    /**
     * Set image on header
     */
    image: {
      type: String,
      default: ''
    },
    /**
     * Set button primary label
     */
    buttonPrimaryLabel: {
      type: String,
      default: 'Continue Purchase'
    },
    /**
     * Set button secondary label
     */
    buttonSecondaryLabel: {
      type: String,
      default: 'Back to Homepage'
    },
    /**
     * Set button primary disabled
     */
    primaryDisabled: {
      type: Boolean,
      default: false
    },
    /**
     * Set secondary button disabled
     */
    secondaryDisabled: {
      type: Boolean,
      default: false
    },
    /**
     * Set action button orientation.\n
     * Value `horizontal` or `vertical`.
     */
    buttonOrientation: {
      type: String,
      default: 'vertical'
    }
  },
  computed: {
    computedStyle() {
      return `background-image: url('${this.image}')`;
    }
  },
  methods: {
    handleClick(e: any) {
      /**
       * Click card method
       * @event click
       * @type {function}
       */
      this.$emit('click', e);
    },
    handlePrimary(e: any) {
      /**
       * Click primary button
       * @event click-primary
       * @type {function}
       */
      this.$emit('click-primary', e);
    },
    handleSecondary(e: any) {
      /**
       * Click secondary button
       * @event click-secondary
       * @type {function}
       */
      this.$emit('click-secondary', e);
    }
  }
});
